import React from 'react';
import {
    Popover,
    PopoverTrigger,
    IconButton,
    PopoverBody,
    PopoverHeader,
    FormLabel,
    FormControl,
    Switch,
    PopoverContent,
    IconButtonProps,
} from '@chakra-ui/react';
import { UpDownIcon } from '@chakra-ui/icons';

const InactiveFacultyPopover = ({
    showInactive,
    setShowInactive,
    ...props
}: {
    showInactive: boolean;
    setShowInactive: (inactive: boolean) => void;
} & Omit<IconButtonProps, 'aria-label'>) => (
    <Popover>
        <PopoverTrigger>
            <IconButton
                size="sm"
                icon={<UpDownIcon />}
                aria-label="Show inactive faculties"
                variant="ghost"
                {...props}
            />
        </PopoverTrigger>
        <PopoverContent>
            <PopoverHeader fontWeight="bold">Show Inactive Faculties</PopoverHeader>
            <PopoverBody p={4}>
                Inactive faculties are not shown in faculty dropdown unless show all faculties is enabled below.
                <FormControl
                    flexDir="row"
                    display="flex"
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    mt={4}
                    ml="auto"
                >
                    <FormLabel>Show All Faculties:</FormLabel>
                    <Switch isChecked={showInactive} onChange={(ev) => setShowInactive(ev.target.checked)} size="md" />
                </FormControl>
            </PopoverBody>
        </PopoverContent>
    </Popover>
);

export default InactiveFacultyPopover;
